import { Component, Input, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { AbstractFormControlComponent } from "../abstract-form-control";

@Component({
  selector: "ta-textarea",
  templateUrl: "textarea.template.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ]
})
export class TextareaComponent extends AbstractFormControlComponent<string> {
  @Input()
  required: boolean = true;

  @Input()
  get placeholder(): string {
    if (this._placeholder != null) {
      return this._placeholder;
    }
    return this.required ? "" : "Optional";
  }
  set placeholder(val: string) {
    this._placeholder = val;
  }
  private _placeholder: string;

  @Input() disabled: boolean;

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }
}
